import React from 'react';

const LoadingMessage: React.FC = () => {
  return (
    <div
      className="flex justify-start"
      role="status"
      aria-label="Tutor is thinking"
    >
      <div className="max-w-[80%] p-4 bg-gray-50 text-gray-500 mr-auto rounded-lg rounded-tl-sm">
        <div className="flex items-center gap-2">
          <svg
            className="w-4 h-4 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span className="text-base font-normal">Thinking...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingMessage;
